import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BaseComponent } from '../../shared/base.component';
import { SharedService } from '../../shared/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, SelectItem } from 'primeng/primeng';
import { LoaderService } from 'app/layout/shared/loader.service';
import { CapitalizeFirstPipe } from './../pipes/custom-pipes.pipe';
import { FPMessage, GlobalInfo, Severities,RoleAccess, PageKey } from 'app/layout/shared/shared.model';
import { ApprovalJobModel, ClosePopup, CloseVendorPopup, PartDetail, Reject, VendorApproval } from 'app/layout/queues/approval-queue/approval-queue.model';
import { RouteParams } from 'app/layout/technician/technician-jobs/technician-jobs.models';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ApprovalQueueService } from './../../queues/approval-queue/approval-queue.service';
import { ThrowStmt } from '@angular/compiler';

@Component({
    selector: 'vendor-accept-reject-popup',
    templateUrl: 'vendor-approve-reject.component.html'
})

export class VendorAcceptReject extends BaseComponent implements OnInit {

    frmvendorecceptreject: FormGroup;
    rejectApproval = new ApprovalJobModel();
    @Input() selectedRejectq: any[] = [];
    @Output() Close = new EventEmitter<CloseVendorPopup>();
    @Input() View: number;
    @Input() wojobId: number;
    @Input() WoAppointmentId: number;
    @Input() header: string;
    @Input() VendorName: string;
    @Input() IsApprovelDetail: boolean;
    Wojobid: number[] = [];
    VendorApproval: VendorApproval[] = [];
    rights: RoleAccess;


    gi = new GlobalInfo;
    message = new FPMessage;
    popupClose = new CloseVendorPopup;
    rp = new RouteParams;

    submitted: boolean;
    loader: boolean;
    remarks: string;
    isreject: boolean = false;
    Remarksreq: boolean = false;
    CurrentStatus: number;
    qprcustomerid: any;
    qprvendorid: any;
    qprvendorname: any;
    menuid?: number;
    jobId: any;
    woCategoryId: any;
    WoWorkOrderId: any;
    roleAccessList: RoleAccess[] = [];
    roleApproveReject: RoleAccess = new RoleAccess;
    constructor(protected sharedService: SharedService, protected translate: TranslateService,
        private _fb: FormBuilder, private loaderService: LoaderService,
        private confirmationService: ConfirmationService, private _approvalService: ApprovalQueueService,
        private router: Router, private route: ActivatedRoute) {
        super(sharedService, translate);
        this.gi = super.globalInfo();
        this.getRouteParams();
    }
    //view
    //1-approve from inhouse/Field jobs
    //2-Reject from inhouse/Field jobs
    //3-approve from Vendor Approval
    //4-Reject from Vendor Approval
    //5-Company Approval
    //6-Company Reject

    ngOnInit() {
        debugger;
        this.getApprovalRouteParams();
        this.getChildPriviliges();
        this.route.params.subscribe(params => {
            this.jobId = params['id'];
            this.woCategoryId = params['woCategoryId'];
            this.WoWorkOrderId = params['workOrderId'];

        });
        this.getRouteParams();
        this.frmvendorecceptreject = this._fb.group({
            Remarks: [""],
            Isshow: [1]
        });

        if (this.View == 2 || this.View == 4 || this.View == 6) {
            this.frmvendorecceptreject.controls['Remarks'].setValidators([Validators.required]);
            this.Remarksreq = true;
            this.CurrentStatus = 3;
        }
        else {
            this.Remarksreq = false;
            this.CurrentStatus = 2;
            this.frmvendorecceptreject.controls['Remarks'].clearValidators();
            this.frmvendorecceptreject.controls['Remarks'].reset();
        }
        if (this.View == 5) {
            this.frmvendorecceptreject.get('Isshow').setValue(0);
        }


    }

    getChildPriviliges() {

        this.sharedService.getChildPrivileges(super.globalInfo().CompanyId, super.globalInfo().LoginId,
            PageKey.Approval_QueueDetail,
            null)
            .subscribe(s => {
                debugger;
                // s.map(m => this.rights = m)
                // if (this.rights.ViewRights != 1) {
                //    // this.location.back();
                // }

                this.roleAccessList = s;  
                if (this.roleAccessList != null && this.roleAccessList.length != 0) {
                    this.roleApproveReject = this.roleAccessList.find(f => f.MenuId == PageKey.ApprovalQueue_Reject_Job);
                    //this.roleApproveReject.AddRights == 1
                }
            });
    }

    updateApproveReject(data: any, frmValid: boolean) {
        debugger;
        var reject = new Reject();
        this.Wojobid = [];

        this.submitted = true;
        if (frmValid) {
            try {
                this.remarks = data.Remarks;
                this.loaderService.show();
                if (this.selectedRejectq != null && this.selectedRejectq.length != 0 && this.selectedRejectq != undefined) {
                    this.selectedRejectq.map(m => {
                        this.Wojobid.push(m.wojobid);
                        var Vendordata = new VendorApproval();
                        Vendordata.WoJobId = m.wojobid;
                        Vendordata.WoAppointMentId = m.woappointmentid;
                        Vendordata.WorkOrderId = m.workorderid;
                        this.VendorApproval.push(Vendordata);
                    });
                }
                else if((this.View ==6 || this.View ==5 ) && this.IsApprovelDetail)
                {
                    this.Wojobid.push(this.rp.WoJobId);
                    var Vendordata = new VendorApproval();
                    Vendordata.WoJobId = this.rp.WoJobId;
                    Vendordata.WoAppointMentId = this.WoAppointmentId;
                    Vendordata.WorkOrderId = this.rp.WorkOrderId;
                    this.VendorApproval.push(Vendordata);
                }
                else {
                    this.Wojobid.push(this.wojobId);
                    var Vendordata = new VendorApproval();
                    Vendordata.WoJobId = this.wojobId;
                    Vendordata.WoAppointMentId = this.WoAppointmentId;
                    Vendordata.WorkOrderId = this.WoWorkOrderId;
                    this.VendorApproval.push(Vendordata);
                }

                reject.CompanyId = this.gi.CompanyId;
                reject.LoginId = this.gi.LoginId;
                reject.CreatedSourceId = 1;
                reject.Remarks = this.remarks;
                reject.WoJobId = this.Wojobid;
                reject.CreatedBy = this.gi.LoginId;
                reject.VendorApproval = this.VendorApproval;
                reject.VendorApprovalStatusId = this.CurrentStatus;
                reject.ViewId = this.View;
                reject.ShowVendor = data.Isshow;
                reject.ApproverName = this.VendorName;
                debugger;
                if (this.View == 1) {
                    this._approvalService.updateVendorApprove(reject)
                        .subscribe(res => {
                            debugger;
                            this.loaderService.hide();
                            this.message = res.Message;
                            if (this.message.MessageCode == "1002") {
                                this.sharedService.notification.emit({
                                    severity: Severities[this.message.Severity],
                                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                                    detail: this.translate.instant("VENAPROVE")
                                });
                                this.popupClose = new CloseVendorPopup();
                                this.popupClose.Responce = true;
                                this.popupClose.viewid = this.View;
                                this.Close.emit(this.popupClose);
                            }
                            else {
                                this.sharedService.notification.emit({
                                    severity: Severities[this.message.Severity],
                                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                                    detail: this.translate.instant(this.message.MessageCode)
                                });
                            }
                        }, e => {
                            this.loaderService.hide();
                        });
                }
                else if (this.View == 2) {
                    this._approvalService.updateVendorApproveReject(reject)
                        .subscribe(res => {

                            this.loaderService.hide();
                            this.message = res.Message;
                            if (this.message.MessageCode == "1002") {
                                this.sharedService.notification.emit({
                                    severity: Severities[this.message.Severity],
                                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                                    detail: this.translate.instant("VENREJECT")
                                });
                                this.popupClose = new CloseVendorPopup();
                                this.popupClose.Responce = true;
                                this.popupClose.viewid = this.View;
                                this.Close.emit(this.popupClose);
                            }
                            else if (this.message.MessageCode == "5017") {
                                this.sharedService.notification.emit({
                                    severity: Severities[3],
                                    summary: CapitalizeFirstPipe.prototype.transform(Severities[3]),
                                    detail: this.translate.instant("5017") + ' ' + this.translate.instant("FOLLOWINGJOB") + this.message.AdditionalInfo
                                });
                            }
                            else {
                                this.sharedService.notification.emit({
                                    severity: Severities[this.message.Severity],
                                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                                    detail: this.translate.instant(this.message.MessageCode)
                                });
                            }
                        }, e => {
                            this.loaderService.hide();
                        });
                }
                else if (this.View == 3) {
                    var PartDetails= new PartDetail()
                    PartDetails.VendorApproval=[];
                    PartDetails.CompanyId=reject.CompanyId;
                    reject.VendorApproval.forEach(e=>{
                        PartDetails.VendorApproval.push(e);
                    })
                  
                    this._approvalService.GetPartStatusCountVendorApprovalQueue(PartDetails)
                    .subscribe(s => {debugger;
                        this.loaderService.hide();
                        if(s.Message != null)
                        {
                        if (s.Message.MessageCode == "2072" || s.Message.MessageCode == "2073") {
                            this.sharedService.notification.emit({ severity: 'error', summary: this.translate.instant('2077')+ ' ' + this.translate.instant("FOLLOWINGJOB")  + s.Message.AdditionalInfo });
                            
                            this.popupClose = new CloseVendorPopup();
                            this.popupClose.Responce = false;
                            this.popupClose.ApproveValue = reject;
                            this.popupClose.viewid = this.View;
                            this.Close.emit(this.popupClose);
                        }
                        else if (s.Message.MessageCode == "9020") {
                            this.sharedService.notification.emit({ severity: 'error', summary: this.translate.instant('9020') + ' ' + this.translate.instant("FOLLOWINGJOB")  + s.Message.AdditionalInfo });
                          
                            this.popupClose = new CloseVendorPopup();
                            this.popupClose.Responce = false;
                            this.popupClose.ApproveValue = reject;
                            this.popupClose.viewid = this.View;
                            this.Close.emit(this.popupClose);
                        }
                        else if (s.Message.MessageCode == "2092")
                        {
                            this.sharedService.notification.emit({ severity: 'error', summary: this.translate.instant('2092') + ' ' + this.translate.instant("FOLLOWINGJOB")  + s.Message.AdditionalInfo });
                            this.popupClose = new CloseVendorPopup();
                            this.popupClose.Responce = false;
                            this.popupClose.ApproveValue = reject;
                            this.popupClose.viewid = this.View;
                            this.Close.emit(this.popupClose);
                        }
                        else {
        
                            this.popupClose = new CloseVendorPopup();
                            this.popupClose.Responce = true;
                            this.popupClose.ApproveValue = reject;
                            this.popupClose.viewid = this.View;
                            this.Close.emit(this.popupClose);
        
                        }
                    }
                    else{
                        this.popupClose = new CloseVendorPopup();
                        this.popupClose.Responce = true;
                        this.popupClose.ApproveValue = reject;
                        this.popupClose.viewid = this.View;
                        this.Close.emit(this.popupClose);
    
                    }
        
                    }, e => { this.loaderService.hide() });
                  
                }
                else if (this.View == 4) {
                    this.popupClose = new CloseVendorPopup();
                    this.popupClose.Responce = true;
                    this.popupClose.ApproveValue = reject;
                    this.popupClose.viewid = this.View;
                    this.Close.emit(this.popupClose);
                }
                else if (this.View == 5)
                {
                    this.popupClose = new CloseVendorPopup();
                    this.popupClose.Responce = true;
                    this.popupClose.ApproveValue = reject;
                    this.popupClose.viewid = this.View;
                    this.Close.emit(this.popupClose);
                }
                else if(this.View == 6)
                {debugger;
                    reject.VendorApprovalStatusId=1;                   
                    if(data.Isshow==1)
                    {
                        reject.ShowVendor= 1 ;
                    }
                    else{
                        reject.ShowVendor= 0;
                    }
                    this._approvalService.updateVendorApproveReject(reject)
                    .subscribe(res => {

                        this.loaderService.hide();
                        this.message = res.Message;
                        if (this.message.MessageCode == "1002") {
                            this.sharedService.notification.emit({
                                severity: Severities[this.message.Severity],
                                summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                                detail: this.translate.instant("VENREJECT")
                            });
                            this.popupClose = new CloseVendorPopup();
                            this.popupClose.Responce = true;
                            this.popupClose.viewid = this.View;
                            this.Close.emit(this.popupClose);
                        }
                        else if (this.message.MessageCode == "5017") {
                            this.sharedService.notification.emit({
                                severity: Severities[3],
                                summary: CapitalizeFirstPipe.prototype.transform(Severities[3]),
                                detail: this.translate.instant("5017") + ' ' + this.translate.instant("FOLLOWINGJOB") + this.message.AdditionalInfo
                            });
                        }
                        else {
                            this.sharedService.notification.emit({
                                severity: Severities[this.message.Severity],
                                summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                                detail: this.translate.instant(this.message.MessageCode)
                            });
                        }
                    }, e => {
                        this.loaderService.hide();
                    });
                }

            }
            catch
            {
                this.loaderService.hide();
            }



        }

    }

    // redirectToApprovalQueueList() {
    //     this.Close.emit(false);
    //     this.router.navigate(['/customview/ApprovalQueue']);
    // }
    getRouteParams(): void {
        debugger
        this.route.queryParams.subscribe(params => {
            this.menuid = params["menuid"];
            this.qprcustomerid = params["idW"];
            this.qprvendorid = params["vvid"];
            this.qprvendorname = params["vvname"];

        });
    }
    getApprovalRouteParams(): void {

        this.route.queryParams.subscribe(params => {
            this.rp.WoJobId = params["idJ"];
            this.rp.WorkOrderId = params["idW"];
            this.rp.ServiceAddressId = params["idSa"];
            this.rp.BillingAddressId = params["idBa"];
            this.rp.WoCategoryId = params["idWoca"];
            this.rp.CustomerId = params["idCus"];
            this.rp.TimeZoneId = params["idTz"];
            this.rp.TechnicianName = params["tName"];
            this.rp.WoNumber = params["noW"];
           
        });
    }

    closePopup() {

        this.popupClose = new CloseVendorPopup();
        this.popupClose.Responce = false;
        this.popupClose.viewid = this.View;
        this.Close.emit(this.popupClose);
        
    }
}